import React from "react";
import PropTypes from 'prop-types';
import Label from './Label';

export default class NoCvButton extends React.PureComponent {

    buttonType = 'button-no-cv';

    static propTypes = {
        language: PropTypes.string,
        positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        customerName: PropTypes.string,
        onClick: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };
    }

    render() {
        return (
            <div className ="col-12 col-md-6">
                <Label
                    positionId={this.props.positionId}
                    customerName = {this.props.customerName}
                    onClick = {this.props.onClick}
                    className = {'d-block height-60 cursor-pointer ' + this.buttonType}
                    buttonType = {this.buttonType}
                >
                    <span className={"d-block padding-top-20 padding-bottom-20"} style={{ paddingLeft: 5, paddingRight: 5 }}>
                        <i className={'fa fa-fw fa-file-signature margin-right-10  padding-left-0-75rem'}/>
                        {window.Translator.getSlug('DontHaveIt', this.props.language)}
                    </span>
                </Label>
            </div>
        )
    }
}
